import React from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import Autocomplete from 'react-places-autocomplete'
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { addNewProperty } from '../api'

const AddPropertyModal = React.createClass({
  getInitialState: function () {
    return {
      address: '',
      imgSrc: '',
      newAddress: '',
      notListed: false
    }
  },
  handleFormSubmit: function(event) {

    geocodeByAddress(this.state.address)
      .then(results => getLatLng(results[0]))
      .then(latLng => console.log('Success', latLng))
      .catch(error => console.error('Error', error))
  },
  onChange: function(updatedAddress) {
    this.setState({address: updatedAddress})
  },
  onSelect: function (address2) {
    let currentAddress = {
      googleAddress: null,
      addressId: null,
      streetAddress: '',
      cityState: '',
      zip: null,
      lng: null,
      lat: null,
      mapURL: null,
      propertyId: null,
      occupiedStatus: true,
      propertyManager: null,
      lawnSize: null
    }
    geocodeByAddress(address2).then(results => {
      currentAddress.googleAddress = results[0].formatted_address
      for (let i = 0; i < results[0]['address_components']['length']; ++i) {
        let addressType = results[0].address_components[i].types[0]
        if (addressType === 'postal_code') {
          currentAddress.zip = results[0]['address_components'][i]['short_name']
        } else if (addressType === 'street_number') {
          currentAddress.streetAddress = results[0]['address_components'][i]['short_name']
        } else if (addressType === 'route') {
          currentAddress.streetAddress += ' ' + results[0]['address_components'][i]['long_name']
        } else if (addressType === 'locality') {
          currentAddress.cityState = results[0]['address_components'][i]['long_name']
        } else if (addressType === 'administrative_area_level_1') {
          currentAddress.cityState += ', ' + results[0]['address_components'][i]['short_name']
        }
      }
    })

    geocodeByAddress(address2)
    .then(results => getLatLng(results[0]))
    .then(({ lat, lng }) => {
      currentAddress.lat = lat
      currentAddress.lng = lng
      currentAddress.lat = lat
      currentAddress.lng = lng
      currentAddress.mapURL = 'https://maps.googleapis.com/maps/api/staticmap?' +
          `center=${lat},${lng}&` +
          `markers=${lat},${lng}&` +
          'zoom=19&size=360x300&scale=4&maptype=satellite&' +
          `key=${window.googleKeys.API_KEY}`
      this.setState({
        address: address2
      })
      this.newAddressSubmit(currentAddress)
    })
  },
  newAddressSubmit: function(address) {
    let fullAddress = address.googleAddress.slice(0, address.googleAddress.length - 5)
    this.setState({
      imgSrc: address.mapURL,
      newAddressChosen: true,
      newAddress: {
        fullAddress: fullAddress,
        streetAddress: address.streetAddress,
        cityState: address.cityState,
        lng: address.lng,
        lat: address.lat,
        zipcode: address.zip,
        mapURL: address.mapURL
      }
    })
  },
  componentDidMount: function () {

  },
  notListedClick: function() {
    this.setState({notListed: true})
  },
  saveAndClose: function() {
    let newAddress = this.state.newAddress

    addNewProperty(this.state.address, newAddress.streetAddress, newAddress.cityState, newAddress.fullAddress, newAddress.lat, newAddress.lng, newAddress.zipcode).then((data) => {
      if(data !== 'error') {
        this.closeModal()
        this.props.refreshPage()
        this.props.openNotificationModal('add-property-modal', "Address Added", "You have successfully added a new property.")
      }
      else {
        this.closeModal()
        this.props.refreshPage()
        this.props.openNotificationModal('add-property-modal', "Processing Error", "There was an error processing your changes. Please try again later.")
      }
    })
  },
  closeModal: function() {
    this.setState({newAddress: '', notListed: false, address: ''})
    this.props.hide()
  },
  orderServices: function() {
    let newAddress = this.state.newAddress

    addNewProperty(this.state.address, newAddress.streetAddress, newAddress.cityState, newAddress.fullAddress, newAddress.lat, newAddress.lng, newAddress.zipcode).then((data) => {
      if(data !== 'error') {
        this.setState({newAddress: '', notListed: false, address: ''})
        this.props.openNewTaskModal(data.data.id, newAddress)
      }
      else {
        this.closeModal()
        this.props.refreshPage()
        this.props.openNotificationModal('add-property-modal', "Processing Error", "There was an error processing your changes. Please try again later.")
      }
    })

  },

  render: function () {
     const inputProps = {
      value: this.state.address,
      onChange: this.onChange,
    }
    let classNames = {
      input: 'google-search-bar',
      autocompleteContainer: 'google-container Select-value-label',
      autocompleteItem: 'google-item',
      autocompleteItemActive: 'google-item'
    }
    return (
      <div >
        <Modal show={this.props.show} onHide={this.closeModal}>
          <div className='white-background'>
            <Modal.Header closeButton>
                <h2 className='text-center'>Add new property</h2>
                <div className='text-center pull-down-xs-2'>
                <form className='form-inline'>
                  <div className='form-group is-search'>
                     <form className={this.state.notListed ? 'hidden' : ''} onSubmit={this.handleFormSubmit}>
                      <Autocomplete classNames={classNames} inputProps={inputProps} onSelect={this.onSelect}/>
                    </form>
                  </div>
                </form>
                </div>
                <div className={this.state.notListed ? 'hidden' : 'text-center pull-down-xs-1'}>
                  <p className='small'><a onClick={this.notListedClick}>Address not listed?</a></p>
                </div>
                <div className={this.state.notListed ? 'hidden' : ''}>
                  <div className={this.state.newAddress === '' ? 'hidden' : 'text-center'}>
                    <img src={this.state.imgSrc} alt='' className='pull-down-xs-2' style={{marginBottom: '5px', height: '255px', width:'345px'}} />
                  </div>
                  <div className='row pull-down-xs-2'>
                    <div className='col-xs-6'>
                      <Button style={{float:'right', zIndex: '1051'}} onClick={this.saveAndClose}type='button' bsClass='btn btn-info btn-sm center-block'>Save and close</Button>
                    </div>
                    <div className='col-xs-6'>
                      <Button style={{float:'left', zIndex: '1051'}} type='button' onClick={this.orderServices} bsClass='btn btn-success btn-sm center-block'>Order Services</Button>
                    </div>
                  </div>
                </div>
                <div className={this.state.notListed ? 'text-center' : 'hidden'}>
                  <p>For assistance in finding your address,<br/>contact us at 800-518-4461</p>
                </div>
            </Modal.Header>
          </div>
        </Modal>
      </div>
    )
  }
})

export default AddPropertyModal



// WEBPACK FOOTER //
// ./src/components/modals/add-property-modal.jsx